// Bootstrap 4のモーダルを確実に表示する関数
function showRankModal(event) {
  // イベントの伝播を確実に停止
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
  
  // Bootstrap 4のモーダルを表示
  try {
    // jQueryとBootstrapが利用可能な場合
    if (typeof $ !== 'undefined' && $.fn.modal) {
      $('#rankInfoModal').modal('show');
    } else {
      // フォールバック: 直接DOM操作
      const modal = document.getElementById('rankInfoModal');
      if (modal) {
        modal.style.display = 'block';
        modal.classList.add('show');
        document.body.classList.add('modal-open');
        
        // 背景のスクロールを防ぐ
        document.body.style.overflow = 'hidden';
        
        // モーダル背景を追加
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'rankModalBackdrop';
        document.body.appendChild(backdrop);
        
        // 背景クリックで閉じる
        backdrop.addEventListener('click', hideRankModal);
        
        // 閉じるボタンのイベント（一度だけ追加）
        if (!modal.hasAttribute('data-listeners-added')) {
          const closeButtons = modal.querySelectorAll('[data-dismiss="modal"]');
          closeButtons.forEach(button => {
            button.addEventListener('click', hideRankModal);
          });
          
          // ESCキーで閉じる
          document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.classList.contains('show')) {
              hideRankModal();
            }
          });
          
          modal.setAttribute('data-listeners-added', 'true');
        }
      }
    }
  } catch (error) {
    console.error('モーダル表示エラー:', error);
  }
}

function hideRankModal() {
  try {
    // jQueryとBootstrapが利用可能な場合
    if (typeof $ !== 'undefined' && $.fn.modal) {
      $('#rankInfoModal').modal('hide');
    } else {
      // フォールバック: 直接DOM操作
      const modal = document.getElementById('rankInfoModal');
      const backdrop = document.getElementById('rankModalBackdrop');
      
      if (modal) {
        modal.style.display = 'none';
        modal.classList.remove('show');
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
      }
      
      if (backdrop) {
        backdrop.remove();
      }
    }
  } catch (error) {
    console.error('モーダル非表示エラー:', error);
  }
}

// グローバルに関数を公開
window.showRankModal = showRankModal;
window.hideRankModal = hideRankModal;